// extracted by mini-css-extract-plugin
export default {"button":"Button_button__VBEM6","outlined":"Button_outlined__UFgI+"};